import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Tabs } from '@/components/ui/tabs';
    import { useFormErrorTabs } from '@/composables/useFormErrorTabs';
    import RoleGeneralForm from '@/components/roles/RoleGeneralForm.vue';
    import RolePermissionsForm from '@/components/roles/RolePermissionsForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleTabs',
  props: {
    form: {}
  },
  setup(__props: any) {

    const props = __props;

    const tabs = [
        { value: 'general', label: 'roles.general_tab_text' },
        { value: 'permissions', label: 'roles.permissions_tab_text' },
    ];

    const fieldToTabMap = {
        name: 'general',
        display_name: 'general',
        description: 'general',

        permission_ids: 'permissions',
    };

    const { currentTab } = useFormErrorTabs(props.form, fieldToTabMap, 'general');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tabs), {
    tabs: tabs,
    modelValue: _unref(currentTab),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentTab) ? (currentTab).value = $event : null))
  }, {
    general: _withCtx(() => [
      _createVNode(RoleGeneralForm, { form: _ctx.form }, null, 8, ["form"])
    ]),
    permissions: _withCtx(() => [
      _createVNode(RolePermissionsForm, { form: _ctx.form }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})